export default {
  lang: {
    reset: 'Atur ulang',
    search: 'Penyaringan',
    expand: 'Perluas',
    collapse: 'Pijakan',
  },
};
